import { RadioButton, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow, TooltipIcon } from "carbon-components-react";
import React, { Component } from "react";
import AssestmentLevelTableLegend from "./AssestmentLevelTableLegend";
import { v4 as uuid } from 'uuid';
//RITM0615454_DEV615_MatriciOutcomes
 //const props = {
 //	validations: {},
 //	outcomeModel,
 //	appMatrixCell,
 //	appMatrixColor,
 //	appProbabilities,
 //      appSeveritiesInvestigation,
 //      isDisabled,
 //	handleChangeAssestmentLevel: () => 0,
 //};

class AssestmentLevelTable extends Component {
	constructor(props){
		super(props);
		this.state = {
			idTable: uuid()
		}
	}
	getTooltip(item) {
		if (!item) return;
		const tooltipObj = {
			1: "Never occurred in the Oil&Gas sector.",
			2: "Already occurred in the Oil&Gas sector. Similar occurrences have already been recorded in the Oil&Gas sector. ",
			3: "Already occurred in the Company. Some similar occurrences have already been recorded in the Saipem group (less than once a year). ",
			4: "It has occurred many times in the Company. Many occurrences have already been recorded in the Saipem group (more than once a year). ",
			5: "It has occurred on the site many times a year. Many occurrences have already been recorded at one particular branch in the Saipem group (more than once a year). ",
		};

		return tooltipObj[item.code];
	}

	handleChangeRadio = (value, property) => {
		const [propertyName ]= property.split("_")
		this.props.handleChangeRadioAssestmentLevel(value, propertyName, this.props.outcomeModel.idOutcome)
	}

	renderMatrixCell = (item) => {
		const idTable = this.state.idTable
		const row = this.props.appMatrixCell[item.code];
		const idSeverity = this.props.outcomeModel?.idInvestigationLevelPotentialConsequenceSeverity;
		const idProbability = this.props.outcomeModel?.idInvestigationLevelPotentialConsequenceProbability;
		const idRealConsequenceSeverity = this.props.outcomeModel?.idInvestigationLevelRealConsequenceSeverity
		return (
			<TableRow key={"row_" + item.id + idTable}>
				<TableCell key={"cell1" + item.id + idTable} style={{ backgroundColor: item.backgroundColor }}>
					{"Level " + item.code + " - " + item.name}
				</TableCell>
				<TableCell key={"cell2" + item.id + idTable} style={{ backgroundColor: this.props.appMatrixColor[row.lvlReal] }}>
					<RadioButton
						id={"lvlReal" + item.id + "_Table_" + idTable}
						key={"lvlReal" + item.id + idTable}
						name={"idInvestigationLevelRealConsequenceSeverity_" + idTable}
						value={item.id}
						labelText={row.lvlReal}
						alt="incidentModel"
						onChange={this.handleChangeRadio}
						checked={idRealConsequenceSeverity === item.id}
						disabled={this.props.isDisabled || this.props.disableLevelRealConsequence}
					/>
				</TableCell>
				{this.props.appProbabilities.map((prob) => (
					<TableCell key={"cell" + item.id + "_" + prob.id + idTable} style={{ backgroundColor: this.props.appMatrixColor[row.lvlPot[prob.code]] }}>
						<RadioButton
							id={"lvlPoten" + item.id + "_" + prob.id + "_Table_" + idTable}
							key={"lvlPoten" + item.id + "_" + prob.id + idTable}
							name={"investigationLevelPotentialConsequence_" + idTable}
							value={item.id + "_" + prob.id}
							labelText={row.lvlPot[prob.code]}
							alt="incidentModel"
							onChange={(value) => this.props.handleChangeInvestigationLvlPotCons(value, this.props.outcomeModel.idOutcome)}
							checked={idSeverity == item.id && idProbability == prob.id}
							disabled={this.props.isDisabled}
						/>
					</TableCell>
				))}
			</TableRow>
		);
	};

	render() {
		const { validations, appMatrixCell, appMatrixColor, appSeveritiesInvestigation } = this.props;
		return (
			<div className="bx--row">
				<div className="bx--col">
					<div>
						<h3 className="title--medium mb-5" >Assessment - Level</h3>
						{this.props.automaticallyCalculated && <small>(Automatically calculated after saving)</small>}
					</div>
					<div className="bx--row table-description">
						<div className="bx--col-lg-12 bx--col-md-12 ">
							<div className="assessment-matrix">
								<TableContainer>
									<Table>
										<TableHead>
											<TableRow>
												<TableHeader rowSpan={2}></TableHeader>
												<TableHeader rowSpan={2} className={validations.idInvestigationLevelRealConsequenceSeverity ? "validations--error" : ""}>
													Investigation Level For Real Consequences*
												</TableHeader>
												<TableHeader colSpan={this.props.appProbabilities.length} className={validations.idInvestigationLevelPotentialConsequenceSeverity ? "validations--error" : ""}>
													Investigation Level For Potential Consequences*
												</TableHeader>
											</TableRow>
											<TableRow>
												{this.props.appProbabilities.map((item) => (
													<TableHeader key={item.id + this.state.idTable}>
														<TooltipIcon
															align="center"
															direction="left"
															tooltipText={this.getTooltip(item)} // }
														>
															{item.name}
														</TooltipIcon>
													</TableHeader>
												))}
											</TableRow>
										</TableHead>
										<TableBody>{appMatrixCell && appMatrixColor && appSeveritiesInvestigation.map((item) => this.renderMatrixCell(item))}</TableBody>
									</Table>
									{validations.idInvestigationLevelRealConsequenceSeverity}
									{validations.idInvestigationLevelPotentialConsequenceSeverity}
								</TableContainer>
							</div>
						</div>
						<div className="bx--col-lg-12 bx--col-md-12 ">
							<AssestmentLevelTableLegend />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default AssestmentLevelTable;
